define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.uiframework = window.lpTag.uiframework || {};

    var ViewEventsHandler = require('web-agent-framework/ViewEventsHandler');

    var configuration = window.LP_UIFRAMEWORK_NAMESPACE || "lpTag";

    var MAX_BINDING_LIMIT = 2000;
    var vcConfig = createConfigurationObject(configuration);

    function createConfigurationObject(configuration) {
        var returnConfig = {namespace: (configuration ? (configuration.namespace || configuration) : window)};

        if (typeof returnConfig.namespace === 'string') {
            var split = returnConfig.namespace.split('.');
            returnConfig.namespace = window;
            for (var i = 0; i < split.length; i++) {
                returnConfig.namespace = returnConfig.namespace[split[i]] = (returnConfig.namespace[split[i]] || {});
            }
        }
        return returnConfig;
    }

    var lpUtils = require('utils/lpUtils');

    vcConfig.namespace.ViewController = function () {
    }; // Everything is on ViewController prototype not on the instance.
    vcConfig.namespace.ViewController.animationEnabled = false;
    /**
     * Extend the ViewController to implement the connection between the View and the JavaScript code
     *
     * The extended JSON object can implement the following:
     *
     * LPViewMap - A mapping of all elements to their classname presentation in the DOM.
     *              This is mostly a declaration of elements, and should not be overridden.
     *
     * initialize - [optional function] Write all view creation here - Called only upon instantiation.
     * events - [optional function] Write all the binding here - Called only upon instantiation.
     * render - [optional function] Write all rendering logic here, this method can be called at any time.
     *
     * instantiation may contain the following json object:
     *
     *      styleFile - The style filename to use
     *      templateFile - The filename to use as a template
     *      template - A string representing the template to use
     *      view - A view to use in this view, it is still wrapped in a div
     *      _id : An id to set to this view
     *      className : The className to set to this view
     *
     * @param jsonClass
     * @return {Function} - The actual ViewController to instantiate
     *
     * @author Adi Cicurel
     */
    vcConfig.namespace.ViewController.extend = function (jsonClass, extendViewController) {
        var VC = function (initParams) {
            if (!initParams) {
                initParams = {};
            }
            initParams.templateFile = initParams.templateFile || jsonClass.templateFile;
            initParams.template = initParams.template || jsonClass.template;
            initParams.className = initParams.className || jsonClass.className;

            this.initializePrototype(jsonClass);
            this.ControllerName = jsonClass.ControllerName;
            this.isViewController = true;
            VC.instanceCounter = VC.instanceCounter || 0;
            VC.instanceCounter++;

            var prototypeConstructor = (extendViewController ? VC.prototype : null);
            var prototypeContext = ((initParams && initParams.doNotInitializeView) ? null : this); // Using null on parent VCs in order to keep the same context for the child initialize.

            if (vcConfig.namespace.ViewController.initializePlugins) {
                for (var i = 0; i < vcConfig.namespace.ViewController.initializePlugins.length; i++) {
                    vcConfig.namespace.ViewController.initializePlugins[i].call(this, initParams);
                }
            }

            this.initialize = createMethod(prototypeContext, jsonClass.initialize, "initialize", prototypeConstructor, true);
            this.events = createMethod(prototypeContext, jsonClass.events, "events", prototypeConstructor, true);
            this.render = createMethod(prototypeContext, jsonClass.render, "render", prototypeConstructor, false);

            if (!initParams || !initParams.doNotInitializeView) {
                this.viewEventsHandler = VC.prototype.initViewEventsHandler(this);
                this.viewControllers = [];

                initView(this, initParams);

                this.initialize(initParams);
                var that = this;
                setTimeout(function () {
                    var i;
                    if (vcConfig.namespace.ViewController.eventsPlugins) {
                        for (i = 0; i < vcConfig.namespace.ViewController.eventsPlugins.length; i++) {
                            vcConfig.namespace.ViewController.eventsPlugins[i].call(that);
                        }
                    }

                    if (that.events && typeof that.events === 'function') {
                        that.events.call(that);
                    }

                    if (vcConfig.namespace.ViewController.renderPlugins) {
                        for (i = 0; i < vcConfig.namespace.ViewController.renderPlugins.length; i++) {
                            vcConfig.namespace.ViewController.renderPlugins[i].call(that);
                        }
                    }
                    if (that.render && typeof that.render === 'function') {
                        that.render.call(that);
                    }

                    if (initParams && initParams.onInitialize) {
                        initParams.onInitialize.call(that);
                    }
                }, 10);
            }
        };

        VC.ControllerName = jsonClass.ControllerName;
        VC.applicationType = jsonClass.applicationType;

        var prototypeConstructor = extendViewController || vcConfig.namespace.ViewController;
        VC.prototype = new prototypeConstructor({doNotInitializeView: true});

        for (var param in jsonClass) {
            if (jsonClass.hasOwnProperty(param)) {
                var ignoredFunction = param === 'initialize' || param === 'events' || param === 'render';

                if (!ignoredFunction) { // Ignoring initialize/events/render functions since they are set in the constructor.
                    if (typeof VC.prototype[param] === 'object') { // If its an object with the same name than uniting them to one.
                        for (var objProp in jsonClass[param]) {
                            if (VC.prototype[param][objProp] && !VC.prototype.hasOwnProperty(param)) {
                                VC.prototype[param] = clone(VC.prototype[param]);
                            }

                            VC.prototype[param][objProp] = jsonClass[param][objProp];
                        }
                    } else {
                        VC.prototype[param] = jsonClass[param];
                    }
                }
            }
        }
        VC.extend = function (extendJsonClass) {
            return vcConfig.namespace.ViewController.extend(extendJsonClass, VC);
        };

        VC.constructor = VC;

        return VC;

        function clone(obj) {
            var newObj = {};
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    newObj[prop] = obj[prop];
                }
            }
            return newObj;
        }

        function createMethod(context, funcToCall, funcName, innerPrototypeConstructor, removeAfterExecution) {
            return function (constructorData) {
                try {
                    if (innerPrototypeConstructor && innerPrototypeConstructor[funcName]) {//this code calls the prototype chain function in case of inheritance
                        innerPrototypeConstructor[funcName].call(context || this, constructorData);
                    }
                    if (funcToCall) {
                        funcToCall.call(context || this, constructorData);//this runs the function from the actual instance
                        if (removeAfterExecution && context) {
                            context[funcName] = function () {
                                this.logger.error("function " + funcName + " already executed");
                                return {error: "Function " + funcName + " already executed!"};
                            };
                        }
                    }
                } catch (callEx) {
                    this.logger.error("found error executing " + funcName + " : " + callEx.message);
                }
            };
        }

        function initView(context, constructorData) {
            if (constructorData) {
                constructorData._id = constructorData._id || constructorData.elementId;

                if (constructorData.styleFile) {
                    // require(constructorData.styleFile);
                    lpUtils.loadResource(constructorData.styleFile);
                }

                if (constructorData.templateFile) {
                    constructorData.template = require('web-agent-templates/' + constructorData.templateFile);
                    // constructorData.template = lpUtils.loadResource('web-agent-templates/' + constructorData.templateFile);
                }

                if (constructorData.view) {
                    context.view = constructorData.view;
                    context.alreadyInDOM = true;
                } else if (constructorData.selector) {
                    context.view = context.getFirstElement(constructorData.selector, document.body);
                    context.alreadyInDOM = true;
                } else if (constructorData._id) {
                    context.view = context.getFirstElement("#" + constructorData._id);
                    context.alreadyInDOM = true;
                } else if (constructorData.template) {
                    context.view = document.createElement('div');
                    context.view.innerHTML = constructorData.template;
                } else {
                    context.view = document.createElement('div');
                }

                if (constructorData.className) {
                    context.view.className = constructorData.className;
                }

                if (constructorData._id) {
                    context.view.id = constructorData._id;
                }

            } else {
                context.view = document.createElement('div');
            }

            context.view.id = "LP_" + context.ControllerName + "_" + VC.instanceCounter;

            if (constructorData && constructorData.hidden) {
                vcConfig.namespace.ViewController.prototype.lpHide.call(context);
            } else {
                vcConfig.namespace.ViewController.prototype.lpShow.call(context);
            }

            context.injectTextDefaults(context.view, constructorData ? constructorData.textInjection : null);
        }
    };

    vcConfig.namespace.ViewController.removeAllPlugins = function () { // This only affects the next initialization of ViewController
        vcConfig.namespace.ViewController.initializePlugins = [];
        vcConfig.namespace.ViewController.eventsPlugins = [];
        vcConfig.namespace.ViewController.disposePlugins = [];
        vcConfig.namespace.ViewController.renderPlugins = [];
    };

    vcConfig.namespace.ViewController.plugin = function (jsonObject) {
        if (jsonObject) {
            for (var prop in jsonObject) {
                if (jsonObject.hasOwnProperty(prop)) {
                    try {
                        switch (prop) {
                            case "dispose" :
                            case "initialize" :
                            case "events" :
                            case "render" :
                                var arrayName = prop + "Plugins";
                                vcConfig.namespace.ViewController[arrayName] = vcConfig.namespace.ViewController[arrayName] || [];
                                vcConfig.namespace.ViewController[arrayName].push(jsonObject[prop]);
                                break;
                            default:
                                if (vcConfig.namespace.ViewController.prototype[prop]) {
                                    this.logger.error("Plugin is trying to override existing property [" + prop + "]");
                                }
                                vcConfig.namespace.ViewController.prototype[prop] = jsonObject[prop];
                        }
                    } catch (e) {
                        this.logger.error("Plugin failed to add property [" + prop + "]" + " : " + e.message);
                    }
                }
            }
        }
    };

    /**
     * Initialize the prototype of ViewController with parameters, this is called from first instantiation since we want the document loaded first.
     *
     * @param jsonClass
     */
    vcConfig.namespace.ViewController.prototype.initializePrototype = function (jsonClass) {
        if (vcConfig.namespace.ViewController.prototypeInitialized) {
            return;
        }

        if (!document.body) {
            return;
        }
        vcConfig.namespace.ViewController.viewEventsHandler = new ViewEventsHandler(vcConfig.namespace.ViewController.prototype.logger);

//    vcConfig.namespace.ViewController.prototype.supportAnimation = !!window.addEventListener;
        vcConfig.namespace.ViewController.prototype.supportTransitions = (document.body.style.MozTransition === '' || document.body.style.WebkitTransition === '' || document.body.style.OTransition === '' || document.body.style.transition === '');
        vcConfig.namespace.ViewController.prototype.supportAnimation = vcConfig.namespace.ViewController.prototype.supportTransitions;
        vcConfig.namespace.ViewController.prototype.eventType = vcConfig.namespace.ViewController.viewEventsHandler.eventType;

        vcConfig.namespace.ViewController.prototypeInitialized = true;
    };

    vcConfig.namespace.ViewController.prototype.initViewEventsHandler = function (context) {
        return {
            bindEvent: function (event) {
                event = event || {};
                event.context = event.context || context;
                vcConfig.namespace.ViewController.viewEventsHandler.bindEvent(event);
            },
            unbindEvent: function (event) {
                event = event || {};
                event.context = event.context || context;
                vcConfig.namespace.ViewController.viewEventsHandler.unbindEvent(event);
            },
            fireEvent: function (event) {
                event = event || {};
                //event.context = event.context || context;
                vcConfig.namespace.ViewController.viewEventsHandler.fireEvent(event);
            },
            disposeEventData: function(appName){
                vcConfig.namespace.ViewController.viewEventsHandler.disposeEventData(appName);
            },
            eventType: vcConfig.namespace.ViewController.viewEventsHandler.eventType,
            appNames: vcConfig.namespace.ViewController.viewEventsHandler.appNames
        };
    };

    vcConfig.namespace.ViewController.prototype.getFirstProperty = function (data) {
        for (var prop in data) {
            if (data.hasOwnProperty(prop)) {
                return prop;
            }
        }
    };

    var DOMSearchStrategyTypes = {
        CLASS: {
            prefix: '.',
            matchFunction: function (elm, selector) {
                var match = vcConfig.namespace.ViewController.prototype.hasClass(elm, selector)[0];
                return match;
            }},
        ID: {
            prefix: '#',
            matchFunction: function (elm, selector) {
                var match = elm.id === selector;
                return match;
            }}
    };


    /* search a child parent element by a selector.
     *
     * PARAMS:
     *
     *      element: a child DOM Element as the root for the search.
     *      parentSelector: a parent selector for search, prefixed with '.' for class search or '#' for id search.
     *      container: a DOM element act as a container for the parent and child to restrict the search, the default id 'window'
     *
     * USAGE:
     *
     *       getParentElementBySingleSelector(descendantDomElement, '.parentClass');
     *
     * INFO:
     *
     *      the function will travels up the dom tree until it will find the parent element with the selector.
     *      if the parent is not found, the function will return null value.
     * */
    vcConfig.namespace.ViewController.prototype.getParentElementBySingleSelector = function (element, parentSelector, container) {

        if (!element) {
            return null;
        }
        if (!parentSelector) {
            return element.parentNode;
        }

        var pElement = element;                              // setting the parent element to the current element.
        var searchStrategy = DOMSearchStrategyTypes.CLASS;         // default strategy for the search.
        var selectorTypePrefix = parentSelector[0];                    // the class/id selector prefix identifyer
        var cleanSelector = parentSelector.substring(1);          // the clean selector without the prefix
        var searchContainer = container || document.body;           // the search container / limiting the search to that DOM Element.

        // find the search strategy by the prefix of the parent selector.
        for (var strategy in DOMSearchStrategyTypes) {
            if (DOMSearchStrategyTypes.prefix == selectorTypePrefix) {
                searchStrategy = strategy;
                break;
            }
        }

        do {

            pElement = pElement.parentNode;
            if (searchStrategy.matchFunction(pElement, cleanSelector)) {
                return pElement;
            }

        } while (pElement && pElement !== searchContainer);

        return null;
    };

    vcConfig.namespace.ViewController.prototype.getFirstElement = function (elementName, view) {
        var queryView = view || this.view;

        if (!elementName) {
            return queryView;
        }

        if (elementName.nodeType === this.elementTypes.ELEMENT) {
            return elementName;
        }

        var elements = this.getElements(elementName, queryView);

        if (elements && elements.nodeType !== this.elementTypes.ELEMENT && (elements.constructor === Array || elements.constructor === NodeList || elements.constructor === HTMLCollection)) {
            return elements[0];
        }

        return elements;
    };

    vcConfig.namespace.ViewController.prototype.getElements = function (elementName, view) {
        if (elementName === 'body') {
            return [document.body];
        }
        //TODO trim selector
        var queryView = view && view.nodeType === this.elementTypes.ELEMENT ? view : this.view;
        if (elementName !== "" && typeof elementName === 'string' && elementName.length > 0) {
            switch (elementName.charAt(0)) {
                case "#":
                    var element = document.getElementById(elementName.substring(1));
                    if (element) {
                        return [element];
                    }
                    break;
                case ".":
                    return this.getElementsByClass(queryView, elementName.substring(1), []);
                default:
                    if (elementName.indexOf('<') < 0) { // to make sure its not HTML as string - cause a runtime exception on the Visitor List
                        return queryView.getElementsByTagName(elementName);
                    }
                    break;
            }
        }

        return [];
    };

    vcConfig.namespace.ViewController.prototype.getElementsByClass = function (parent, queryClass, resultArray) {
        if (!parent || parent.nodeType !== this.elementTypes.ELEMENT) {
            return resultArray;
        }

        if (parent && parent.className && this.hasSingleClass(parent, queryClass)) {
            resultArray.push(parent);
        }

        var res;
        if (document.getElementsByClassName) {
            res = parent.getElementsByClassName(queryClass);
        } else {
            res = parent.querySelectorAll('.' + queryClass);
        }
        for (var i = 0; i < res.length; i++) {
            resultArray.push(res[i]);
        }

        return resultArray;
    };

    vcConfig.namespace.ViewController.prototype.preventDefault = function (e) {
        if (!e) {
            return;
        }
        if (e.preventDefault) {
            e.preventDefault();
        } else {
            e.returnValue = false;
        }
    };

    vcConfig.namespace.ViewController.prototype.stopPropagation = function (e) {
        if (!e) {
            return;
        }

        if (e.stopPropagation) {
            e.stopPropagation();
        } else {
            e.cancelBubble = true;
        }
    };

    vcConfig.namespace.ViewController.prototype.hasSingleClass = function (element, queryClass, removeClass) {
        var response = this.hasClass(element, queryClass, removeClass);
        response = response.length === 1 ? response[0] : response;
        return response;
    };

    vcConfig.namespace.ViewController.prototype.hasAtLeastOneClass = function (element, queryClass, removeClass) {
        var response = this.hasClass(element, queryClass, removeClass);
        for (var i = 0; i < response.length; i++) {
            if (response[i]) {
                return true;
            }
        }

        return false;
    };

    vcConfig.namespace.ViewController.prototype.hasClass = function (element, queryClass, removeClass) {
        if (typeof element === "string") {
            element = this.getFirstElement(element);
        }

        queryClass = queryClass.constructor === Array ? queryClass : [queryClass];
        var response = [];

        for (var k = 0; k < queryClass.length; k++) {
            response.push(false);
        }
        var resClass = "";
        if (element && element.nodeType === this.elementTypes.ELEMENT && typeof element.className !== 'undefined') {
            var classes = element.className.split(' ') || element.className;
            var includeClass;

            for (var i = 0; i < classes.length; i++) {
                includeClass = true;
                for (var j = 0; j < queryClass.length; j++) {
                    if (queryClass[j] === classes[i]) {
                        response[j] = true;
                        includeClass = false;
                    }
                }
                if (removeClass && includeClass) {
                    resClass += ' ' + classes[i];
                }
            }

            if (removeClass) {
                resClass = resClass.replace(/^\s\s*/, '');
                element.className = resClass;
            }
        }
        return response;
    };

    vcConfig.namespace.ViewController.prototype.addClassMultiElements = function (elements, newClass) {
        if (typeof elements === "string") {
            elements = this.getElements(elements);
        }
        for (var i = 0; i < elements.length; i++) {
            this.addClass(elements[i], newClass);
        }
    };

    /**
     * toggles a class-name on the passed element.
     *
     * @param element the target element for the toggle, can be a DOM element, or a string selector.
     * @param className the class-name to be toggled.
     * @param state the toggle state, truthy value means add the class, falsey value means remove it.
     */
    vcConfig.namespace.ViewController.prototype.toggleClass = function (element, className, state) {
        if (typeof element === "string") {
            element = this.getFirstElement(element);
        }
        if (element && element.nodeType === this.elementTypes.ELEMENT) {
            if (!!state) {
                this.addClass(element, className);
            } else {
                this.removeClass(element, className);
            }
        }
    };

    vcConfig.namespace.ViewController.prototype.addClass = function (element, newClass) {
        if (typeof element === "string") {
            element = this.getFirstElement(element);
        }
        newClass = newClass.constructor === Array ? newClass : [newClass];

        if (element && element.nodeType === this.elementTypes.ELEMENT) {
            var newClassName = element.className;
            if (newClassName) {
                var classesToAdd = this.hasClass(element, newClass);
                for (var i = 0; i < classesToAdd.length; i++) {
                    if (classesToAdd[i] === false) {
                        newClassName += ' ' + newClass[i];
                    }
                }
            } else {
                for (var j = 0; j < newClass.length; j++) {
                    newClassName += newClass[j] + ' ';
                }
            }
            newClassName = newClassName.replace(/^\s\s*/, '');
            element.className = newClassName;
        } else {
            this.logger.error("Unable to add class to " + element + " Class: " + newClass, "addClass");
        }
    };

    vcConfig.namespace.ViewController.prototype.setAttributeMultiElements = function (elements, attrName, attrValue) {
        if (typeof elements === "string") {
            elements = this.getElements(elements);
        }
        for (var i = 0; i < elements.length; i++) {
            this.setAttribute(elements[i], attrName, attrValue);
        }
    };


    vcConfig.namespace.ViewController.prototype.setAttribute = function (element, attrName, attrValue) {
        if (typeof element === "string") {
            element = this.getFirstElement(element);
        }

        if (element && element.nodeType === this.elementTypes.ELEMENT) {
            try {
                if (element.setAttribute) {
                    element.setAttribute(attrName, attrValue);
                } else {
                    element.setProperty(attrName, attrValue);
                }
            } catch (exc) {
                this.logger.error("Unable to set attribute" + attrName + " to " + attrValue, "setAttribute");
            }
        } else {
            this.logger.error("Can't set attribute" + attrName + " to " + attrValue + " to none DOM nodes", "setAttribute");
        }
    };

    vcConfig.namespace.ViewController.prototype.removeClassMultiElements = function (elements, classToRemove, removeFromChildren) {
        if (typeof elements === "string") {
            elements = this.getElements(elements);
        }
        for (var i = 0; i < elements.length; i++) {
            this.removeClass(elements[i], classToRemove, removeFromChildren);
        }
    };

    vcConfig.namespace.ViewController.prototype.removeClass = function (element, classToRemove, removeFromChildren) {
        if (typeof element === "string") {
            element = this.getFirstElement(element);
        }
        if (element && element.nodeType === this.elementTypes.ELEMENT) {
            this.hasClass(element, classToRemove, true);

            if (removeFromChildren && element.hasChildNodes()) {
                var children = element.childNodes;
                for (var i = 0; children.length; i++) {
                    if (children[i].nodeType === this.elementTypes.ELEMENT) {
                        this.removeClass(children[i], classToRemove, removeFromChildren);
                    }
                }
                children = null;
            }
        } else {
            this.logger.error("Unable to remove class to " + element + " Class: " + classToRemove, "addClass");
        }

    };

    vcConfig.namespace.ViewController.prototype.removeAttributeMultiElements = function (elements, attrName) {
        if (typeof elements === "string") {
            elements = this.getElements(elements);
        }
        for (var i = 0; i < elements.length; i++) {
            this.removeAttribute(elements[i], attrName);
        }
    };

    vcConfig.namespace.ViewController.prototype.removeAttribute = function (element, attrName) {
        if (typeof element === "string") {
            element = this.getFirstElement(element);
        }

        if (element && element.nodeType === this.elementTypes.ELEMENT) {
            try {
                if (element.removeAttribute) {
                    element.removeAttribute(attrName);
                } else {
                    element.removeProperty(attrName);
                }
            } catch (exc) {
                this.logger.error("Unable to remove attribute" + attrName, "removeAttribute");
            }
        } else {
            this.logger.error("Can't set remove" + attrName + " from none DOM nodes", "removeAttribute");
        }
    };

    /**
     * This method binds a view action to a callback or viewEventHandler
     *
     * The request should contain the following parameters:
     * selector - The selector of views to bind the actions
     * DOMEvent - The dom event we would like to bind this action
     * appName  - [optional] if given, an UIEvent is fired to the viewEventHandler
     * appEvent - [optional] only relevant if the appName is given, and optional to override the DOMEvent for viewEventHandler events
     * callback - [optional] The callback is called when the event is triggered, and before the UIEvent fires
     *            The callback method signature receives an 'event'
     *            [optional] can place 'preventFireUIEvent=true' in order to ignore the UI event triggering
     *            [optional] can place 'eventData={}' in order to pass additional data to the viewEventHandler listeners
     * ignoreChildBlur - [optional] in case you it is a bind to a "blur" event, you can choose to ignore "blur" that came from one of your child's elements
     * includeSelf - [optional] in case you added the "ignoreChildBlur", you can choose if you want to include your own object as part of the contains answer.
     *
     * @param request
     */
    vcConfig.namespace.ViewController.prototype.bindViewEvent = function (request) {
        if (!request || !request.DOMEvent) {
            return;
        }
        if (!this.bindedViewEventsMap) {
            this.bindedViewEventsMap = [];
        }

        if(this.bindedViewEventsMap.length > MAX_BINDING_LIMIT){
            this.logger.warn('ViewController [' + (this.ControllerName || this.applicationType) + '] has exceeded the maximum number of bindings.', 'bindViewEvent');
        }

        var bindViewEventCallback = this.createViewEvent(request);

        var elements;
        if (request.selector && request.selector === window) {
            elements = [window];
        } else if (request.view) {
            elements = [request.view];
        } else if (request.selector) {
            elements = this.getElements(request.selector, request.inView);
        } else {
            elements = [this.view];
        }

        var event;
        var view;

        for (var index = 0; index < elements.length; index++) {
            view = elements[index];
            if (view) {
                if (view.addEventListener) {
                    event = request.DOMEvent;
                    if (event === 'transition' && this.supportTransitions) {
                        event = this.getTransitionType(event);
                    }
                    //noinspection JSUnresolvedVariable
                    if (event === 'blur' && typeof view.onfocusout !== 'undefined') { // Patch for IE to change to focusout, firefox does not support it.
                        event = 'focusout';
                    }
                    view.addEventListener(event, bindViewEventCallback, false);
                } else if (view.attachEvent) {
                    event = request.DOMEvent;
                    if (event === 'blur') {
                        event = "focusout"; // Patch for IE 8
                    }
                    view.attachEvent("on" + event, bindViewEventCallback);
                }
                this.bindedViewEventsMap.push({view: view, DOMEvent: event, callback: bindViewEventCallback, originalCallback: request.callback});
                view = null;
            }
        }

        view = null;
        event = null;
        elements = null;
    };

    vcConfig.namespace.ViewController.prototype.createViewEvent = function (request) {
        var that = request.context || this;
        return function (e) {
            e = e || event;

            if (request.ignoreChildBlur) {
                var scope = request.selector ? that.getFirstElement(request.selector) : that.view;
                if (that.isEventFromChild(e, scope, request.includeSelf)) {
                    return;
                }
            }

            if (request.callback && typeof request.callback === 'function') {
                e.eventSelector = request.selector;
                try {
                    e.sourceElement = e.target || e.relatedTarget || e.srcElement;

                    e.lpEventData = request.lpEventData;

                    if (request.delayEvent && !isNaN(request.delayEvent)) {
                        setTimeout(function () {
                            request.callback.call(that, e);
                        }, request.delayEvent);
                    } else {
                        request.callback.call(that, e);
                    }
                } catch (err) {
                    that.logger.error('error in event of type ' + e.type, 'createViewEvent', err);
                }
            }

            if (request.appName && !e.preventFireUIEvent) {
                vcConfig.namespace.ViewController.viewEventsHandler.fireEvent({
                    appName: request.appName,
                    UIEvent: (request.UIEvent || request.DOMEvent),
                    eventData: e.eventData
                });
            }
        };
    };

    vcConfig.namespace.ViewController.prototype.getTransitionDuration = function () {
        if (document.body.style.MozTransition === '') {
            return '-moz-transition-duration';
        } else if (document.body.style.WebkitTransition === '') {
            return '-webkit-transition-duration';
        } else if (document.body.style.OTransition === '') {
            return '-o-transition-duration';
        } else {
            return 'transition-duration';
        }
    };

    vcConfig.namespace.ViewController.prototype.getTransitionType = function (event) {
        if (document.body.style.MozTransition === '') {
            event = 'transitionend';
        } else if (document.body.style.WebkitTransition === '') {
            event = 'webkitTransitionEnd';
        } else if (document.body.style.OTransition === '') {
            event = 'OTransitionEnd';
        } else { // this should happen only in IE10
            event = 'transitionend';
        }
        return event;
    };

    /**
     * Should handle focusout looks if any of the element or one of its parents is an lpview_ element
     * If so, checking if the related element is one of its children.
     *
     * This is mostly a fix for IE, if one of the labels/spans/links inside a menu is clicked,
     * we do not want to handle the focus out on that... only on the menu div.
     *
     * [Adi 14/Oct/2012] - Fix for IE
     * @param e
     * @param scope
     * @return {Boolean}
     */
    vcConfig.namespace.ViewController.prototype.isEventFromChild = function (e, scope, includeSelf) {
        if (e.type === 'focusout' || e.type === 'blur' && (e.relatedTarget || e.toElement || e.rangeParent || e.explicitOriginalTarget)) {
            var src = e.toElement || e.relatedTarget || e.rangeParent || e.explicitOriginalTarget;
            var target = e.target || e.srcElement;
            if (e.type === 'focusout' || e.type === 'blur') {
                var result = scope.contains(src);
                if (includeSelf) {
                    return !!result || src === target;
                } else {
                    return !!result && src !== target;
                }
            }
        }
    };

    vcConfig.namespace.ViewController.prototype.isFromChild = function (e, scope, includeSelf) {
        if (e) {
            var target = e.target;
            var currentTarget = e.currentTarget;
            if(target && currentTarget) {
                var result = scope.contains(target);
                if (includeSelf) {
                    return !!result || currentTarget === target;
                } else {
                    return !!result && currentTarget !== target;
                }
            }
        }
    };

    vcConfig.namespace.ViewController.prototype.getViewEvent = function (eventData) {
        if (!this.bindedViewEventsMap) {
            return;
        }

        var resEvent;
        for (var i = 0; i < this.bindedViewEventsMap.length; i++) {
            var bindedEvent = this.bindedViewEventsMap[i];
            if (bindedEvent && bindedEvent.view === eventData.view && bindedEvent.DOMEvent === eventData.DOMEvent && (eventData.callback === bindedEvent.callback || eventData.callback === bindedEvent.originalCallback)) {
                resEvent = bindedEvent;
                resEvent.index = i;//Set index so we can clear the array position
                return resEvent;
            }
        }
        return resEvent;
    };

    vcConfig.namespace.ViewController.prototype.unbindViewEvent = function (eventInfo) {
        var eventsToRemove = eventInfo || this.bindedViewEventsMap || [];
        eventsToRemove = eventsToRemove.constructor === Array ? eventsToRemove : [eventsToRemove];
        var eventData, elements;
        for (var i = 0; i < eventsToRemove.length; i++) {
            eventData = eventsToRemove[i];
            if (eventData && eventData.selector) {
                elements = this.getElements(eventData.selector, eventData.inView);
                for (var j = 0; j < elements.length; j++) {
                    unbindSingleViewEvent(this.getViewEvent({view: elements[i], DOMEvent: eventData.DOMEvent, callback: eventData.callback}), this.bindedViewEventsMap, this.logger);
                }
            } else {
                unbindSingleViewEvent(this.getViewEvent(eventData), this.bindedViewEventsMap, this.logger);
            }
        }
        elements = null;
        eventData = null;
        eventsToRemove = null;

        function unbindSingleViewEvent(singleEventInfo, bindedViewEventsMap, log) {
            try {
                if (singleEventInfo && singleEventInfo.view) {
                    if (window.removeEventListener) {
                        singleEventInfo.view.removeEventListener(singleEventInfo.DOMEvent, singleEventInfo.callback, false);
                    } else if (window.detachEvent) {
                        singleEventInfo.view.detachEvent('on' + singleEventInfo.DOMEvent, singleEventInfo.callback);
                    }
                    if (bindedViewEventsMap[singleEventInfo.index]) {//Remove from binded events list to nullify pointers
                        bindedViewEventsMap[singleEventInfo.index] = null;
                        bindedViewEventsMap.splice(singleEventInfo.index, 1);
                    }
                }
            } catch (exc) {
                log.error(exc + ' ' + exc.message, "unbindSingleViewEvent");
            }
        }
    };

    /**
     * @deprecated
     *
     * @param view
     * @param parentScope
     * @param animate
     */
    vcConfig.namespace.ViewController.prototype.lpHide = function (view, parentScope, animate) {
        this.hide(view, parentScope, animate);
    };
    /**
     * default hide function for every viewController
     */
    vcConfig.namespace.ViewController.prototype.hide = function (view, parentScope, animate) {
        if (!view || view == this.view) {
            this.visible = false;
        }

        var viewToHide = view || this.view;

        if (parentScope) {
            parentScope = typeof parentScope === 'string' ? this.getFirstElement(parentScope) : parentScope;
        }

        if (typeof viewToHide === 'string') {
            viewToHide = this.getFirstElement(viewToHide, parentScope);
        }

        if (viewToHide && viewToHide.nodeType === this.elementTypes.ELEMENT) {
            if (animate) {
                this.animate(viewToHide, {duration: 250, opacity: 0}, function () {
                    viewToHide.style.display = 'none';
                    viewToHide = null;
                });
            } else {
                viewToHide.style.display = 'none';
                viewToHide = null;
            }

        } else {
            this.logger.error("Received viewToHide which is not a view or string - " + view, "lpHide");
        }
    };
    vcConfig.namespace.ViewController.prototype.focus = function (view) {
        if (!view) {
            return;
        }
        if (typeof view === 'string') {
            view = this.getFirstElement(view);
        }

        var height = parseInt(this.getComputedStyle(view, "height"), 10);

        if (height) {
            view.focus();
        }

        view = null;
    };

    vcConfig.namespace.ViewController.prototype.isVisible = function (view) {
        var viewToCheck = view;
        if (typeof view === 'string') {
            viewToCheck = this.getFirstElement(view);
        }

        if (viewToCheck && viewToCheck.nodeType === this.elementTypes.ELEMENT) {
            return this.getComputedStyle(viewToCheck, 'display') !== 'none';
        }
        return false;
    };

    /**
     * @deprecated
     *
     * @param view
     * @param parentScope
     * @param animate
     */
    vcConfig.namespace.ViewController.prototype.lpShow = function (view, parentScope, animate) {
        this.show(view, parentScope, animate);
    };

    /**
     * default show function for every viewController
     */
    vcConfig.namespace.ViewController.prototype.show = function (view, parentScope, animate) {

        if (!view || view === this.view) {
            this.visible = true;
        }

        var viewToShow = view || this.view;

        if (parentScope) {
            parentScope = typeof parentScope === 'string' ? this.getFirstElement(parentScope) : parentScope;
        }
        if (typeof view === 'string') {
            viewToShow = this.getFirstElement(viewToShow, parentScope);
        }

        if (viewToShow && viewToShow.nodeType === this.elementTypes.ELEMENT) {
            var displayProperty = lpUtils.getDefaultDisplayProperty(this.view);
            if (animate) {
                viewToShow.style.opacity = 0;
                viewToShow.style.display = displayProperty;
                this.animate(viewToShow, {duration: 250, opacity: 1});
            } else {
                viewToShow.style.display = displayProperty;
            }
        } else {
            this.logger.error("Received viewToShow which is not a view or string - " + view, "lpShow");
        }

        viewToShow = null;
    };

    /**
     * Creating a view inside a div,
     * possible parameters:
     * styleFile - [optional] The style file to load for this view
     * templateFile - [optional]  The file presenting the template to use
     * template - The template to use to build this view
     * hidden - [optional] Hiding the view upon creation
     * doNotAddChild - [optional] Do not add the view to this.view
     * target - [optional] Selector to add the new view to.
     *
     * @param request
     * @return The new view created
     */
    vcConfig.namespace.ViewController.prototype.createView = function (request) {
        if (!request || (!request.elementType && !request.template && !request.templateFile)) {
            return undefined;
        }

        var view;

        if (request.styleFile) {
            // require(request.styleFile);
            lpUtils.loadResource(request.styleFile);
        }
        if (request.templateFile) {
            request.template = require('web-agent-templates/' + request.templateFile);
            // request.template = lpUtils.loadResource(request.templateFile);
        }
        if (request.elementType) {
            view = document.createElement(request.elementType);
        } else {
            view = document.createElement("div");
        }
        if (request.template) {
            //TODO: The "useOriginalTemplate" is only used by the Chat View Controller.
            //In the future we should always create the view when we have what we need to
            //Translate the template, and always call the "injectTextDefaults".
            var templateText = request.template.toString();
            if (!request.useOriginalTemplate || request.textInjection || !templateText) {
                templateText = this.injectTextDefaults(request.template, request.textInjection);
            }

            if (!request.type || request.type === "html") {
                view.innerHTML = templateText;
            } else {
                view.appendChild(document.createTextNode(templateText));
            }
        } else {
            view = this.injectTextDefaults(view, request.textInjection);
        }

        if (typeof request.wrapWithDiv === "undefined") {
            request.wrapWithDiv = true;
        }
        if (request.wrapWithDiv) {
            if (request.hidden) {
                view.style.display = "none";
            }

            if (request.name) {
                view.name = request.name;
            }

            if (request.className) {
                view.className = request.className;
            }

            if (request.elementId) {
                view.id = request.elementId;
            }
        } else {
            view = view.firstChild;
            if (request.className) {
                this.addClass(view, request.className);
            }
        }

        if (!request.doNotAddChild) {
            var targetView, beforeView;
            if (request.target) {
                targetView = typeof request.target === "string" ? this.getFirstElement(request.target) : request.target;
            }
            if (request.beforeView) {
                beforeView = typeof request.beforeView === "string" ? this.getFirstElement(request.beforeView) : request.beforeView;
            }

            view = this.addView({targetView: targetView || this.view, viewToAdd: view, beforeView: beforeView});
        }

        request.view = view;
        return view;
    };

    vcConfig.namespace.ViewController.prototype.injectTextDefaults = function (view, replacingTextMap) {
        try {
            if (typeof view === 'string') {
                view = this.templateString(view, replacingTextMap);
            } else if (view.nodeType === this.elementTypes.ELEMENT) {
                if (view.innerHTML !== "") {
                    view.innerHTML = this.templateString(view.innerHTML, replacingTextMap);
                } else {
                    var thisView = view.innerText || view.textContent;
                    if (typeof thisView === 'string') {
                        thisView = this.templateString(thisView, replacingTextMap);
                        if (view.innerText) {
                            view.innerText = thisView;
                        } else {
                            view.textContent = thisView;
                        }
                    }
                }
            }
        } catch (e) {
            this.logger.error("failed to inject text defaults with exception " + e.message, "injectTextDefaults", e);
        }

        return view;
    };

    vcConfig.namespace.ViewController.prototype.templateString = function (view, infoObj) {
        var that = this;
        view = injectText("{{{", "}}}", view, infoObj, false);
        if (infoObj && infoObj.ignoreEscapeHTML) {
            view = injectText("{{", "}}", view, infoObj, false);
        } else {
            view = injectText("{{", "}}", view, infoObj, true);
        }
        return view;

        function injectText(startExpression, endExpression, view, infoObj, escapeText) {
            var replaceString, newText, endIndex = -1, tempString = view, startLen = startExpression.length, endLen = endExpression.length;
            var startIndex = tempString.indexOf(startExpression);
            while (startIndex > -1) {
                startIndex += startLen;
                endIndex = tempString.substring(startIndex).indexOf(endExpression);
                if (endIndex > -1) {
                    replaceString = tempString.substring(startIndex, startIndex + endIndex);
                    newText = (infoObj && infoObj[replaceString]) || (that.translate ? that.translate(replaceString) : replaceString);
                    if (infoObj && typeof infoObj[replaceString] !== 'undefined') {
                        newText = infoObj[replaceString];
                    }
                    if (newText !== undefined) {
                        if (newText instanceof Array) {
                            newText = newText.join(', ');
                        }
                        if (escapeText && lpTag && lpUtils && lpUtils.escapeHTML) {
                            newText = lpUtils.escapeHTML(newText);
                        }
                        view = view.replace(startExpression + replaceString + endExpression, newText);
                    }
                    tempString = tempString.substring(startIndex + endIndex + endLen);
                } else {
                    tempString = tempString.substring(startIndex + endLen);
                }
                endIndex = -1;
                startIndex = tempString.indexOf(startExpression);
            }
            return view;
        }
    };

    vcConfig.namespace.ViewController.prototype.addViewController = function (request) {
        var controller = request.viewController || request;

        if (!controller.isViewController) {
            return { error: "ViewController#addViewController - Request is not a viewController and does not contain viewController" };
        }

        this.viewControllers.push(controller);

        if (request.hidden) {
            controller.lpHide();
        }

        if (!controller.alreadyInDOM) {
            var targetView, beforeView;

            if (request.target) {
                targetView = typeof request.target === "string" ? this.getFirstElement(request.target) : request.target;
            }

            if (request.beforeView) {
                beforeView = typeof request.beforeView === "string" ? this.getFirstElement(request.beforeView) : request.beforeView;
            }

            this.addView({targetView: targetView || this.view, viewToAdd: controller.view, beforeView: beforeView});
            targetView = null;
        }
    };

    vcConfig.namespace.ViewController.prototype.removeView = function (data) {
        if (!data) {
            return;
        }

        var viewToRemove = data.view || data;

        if (viewToRemove && viewToRemove.nodeType === this.elementTypes.ELEMENT && viewToRemove.parentNode) {
            viewToRemove.parentNode.removeChild(viewToRemove);
        }
        viewToRemove = null;
    };

    vcConfig.namespace.ViewController.prototype.addView = function (data) {

        if (!data.targetView || (data.targetView.nodeType !== this.elementTypes.ELEMENT && data.targetView.nodeType !== this.elementTypes.FRAGMENT_DOCUMENT)) {
            this.logger.error("Wrong view to add [" + data.targetView + "]", "addView");
            return;
        }
        var insertBefore = data.beforeView && (data.beforeView.nodeType === this.elementTypes.ELEMENT || data.targetView.nodeType !== this.elementTypes.FRAGMENT_DOCUMENT);
        if (insertBefore) {
            data.targetView.insertBefore(data.viewToAdd, data.beforeView);
        } else {
            data.targetView.appendChild(data.viewToAdd);
        }
        return data.viewToAdd;
    };

    vcConfig.namespace.ViewController.prototype.removeViewController = function (request) {
        var controller = request.viewController || request;

        for (var index in this.viewControllers) {
            if (this.viewControllers.hasOwnProperty(index)) {
                if (this.viewControllers[index] === controller) {
                    controller.dispose();
                    this.viewControllers.slice(index, 1);
                }
            }
        }
    };

    vcConfig.namespace.ViewController.prototype.elementTypes = {
        ELEMENT: 1,
        ATTRIBUTE: 2,
        TEXT: 3,
        COMMENTS: 8,
        DOCUMENT: 9,
        FRAGMENT_DOCUMENT: 11
    };

    vcConfig.namespace.ViewController.prototype.setStyle = function (view, style) {
        var viewToModify;

        if (typeof view === 'string') {
            viewToModify = this.getElements(view);
        } else {
            viewToModify = [view];
        }
        for (var i = 0; i < viewToModify.length; i++) {
            for (var prop in style) {
                if (style.hasOwnProperty(prop)) {
                    viewToModify[i].style[prop] = style[prop];
                }
            }
        }
    };

    vcConfig.namespace.ViewController.prototype.getComputedStyle = function (el, cssprop, radix) {
        var style = {};

        if (typeof el === 'undefined') {
            return '';
        }

        if (typeof el === 'string') {
            el = this.getFirstElement(el);
        }

        if (document.defaultView && document.defaultView.getComputedStyle) { // All normal browsers
            style = document.defaultView.getComputedStyle(el, "");
        } else {
            if (el.currentStyle) { // IE8 IE8 IE8 ....
                if (cssprop === 'height') {//TODO research this MDN-QuirksMode
                    return el.offsetHeight;
                }
                style = el.currentStyle;
            } else {//try and get inline style
                style = el.style;
            }
        }
        if (cssprop) {
            var propertyValue = style.getPropertyValue(cssprop) || style[cssprop];
            if (typeof propertyValue !== "undefined" && typeof radix !== "undefined") {
                propertyValue = parseInt(propertyValue, radix);
            }
            return propertyValue;
        }

        return style;
    };


    vcConfig.namespace.ViewController.prototype.ANIMATION_CLASS_PREFIX = "lpViewAnimationClass";
//TODO externalize CSS3 animations
    /**
     * An example:
     * var that = this;
     * this.animate(this.view, {duration: 300, opacity: "0"}, function() {
 *           that.lpHide.call(that, that.view);
 *      });
     * @param view
     * @param props
     * @param callbackFunc
     */
    vcConfig.namespace.ViewController.prototype.animate = function (view, props, callbackFunc) {
        if (!view || view.nodeType !== this.elementTypes.ELEMENT) {
            return;
        }

        if (!this.supportAnimation) {
            noAnimationOperation(this);
//        } else if (!this.supportTransitions) {
//            noTransitionOperation(this);
        } else {
            performTransitionOperation(this);
        }

        /**
         * No animation at all, just setting the properties.
         */
        function noAnimationOperation(that) {
            for (var prop in props) {
                if (props.hasOwnProperty(prop) && prop !== 'duration') {
                    view.style[prop] = props[prop];
                }
            }
            if (callbackFunc) {
                callbackFunc.call(that);
            }
        }

//
//        /**
//         * No transitions, setting the animation via the animation lib.
//         */
//        function noTransitionOperation (that) {
//            var propsArray = [];
//            for (var prop in props) {
//                if (prop !== 'duration') {
//                    propsArray.push({name : prop, targetVal : parseInt(props[prop], 10)});
//                }
//            }
//
//            var changedId = false;
//            var callback = function () {
//                if (changedId) {
//                    view.id = null;
//                }
//                if (callbackFunc) {
//                    callbackFunc.call(that);
//                }
//                that = null;
//            };
//
//            if (!view.id) {
//                changedId = true;
//                view.id = "ANIMATION_ID_" + Math.random();
//            }
//
//            lpMTagConfig.lpm.lpAnimate.animate(view, propsArray, {easing : 'easeOutQuart', duration : props.duration, callback : callback});
//        }

        /**
         * Performing animation with the add/remove animation class.
         */
        function performTransitionOperation(that) {
            that.addClass(view, that.ANIMATION_CLASS_PREFIX);
            //TODO separate this into another method - CSS3 animation or something
            var event = that.getTransitionType();

            setTimeout(function () {
                setTimeout(function () {
                    if (that.hasClass(view, that.ANIMATION_CLASS_PREFIX)) {
                        that.removeClass(view, that.ANIMATION_CLASS_PREFIX);
                        view.style[that.getTransitionDuration()] = "";
                        if (callbackFunc) {
                            setTimeout(function () {
                                callbackFunc.call(that);
                            }, 0);
                        }
                    }
                }, props.duration);

                for (var prop in props) {
                    if (props.hasOwnProperty(prop)) {
                        if (prop === 'duration') { // TODO: Support all browsers animation
                            view.style[that.getTransitionDuration()] = props[prop] + "ms";
                        } else {
                            view.style[prop] = props[prop];
                        }
                    }
                }

            }, 0);
        }
    };

    vcConfig.namespace.ViewController.prototype.stopAnimate = function (view) {
        this.removeClass(view, this.ANIMATION_CLASS_PREFIX);
        view.style[this.getTransitionDuration()] = "";
    };

    vcConfig.namespace.ViewController.prototype.dispose = function () {
        if (this.disposed) {
//        this.logger.error("View Controller is already disposed", 'dispose');
            return "ViewController Already disposed";
        }

        var i;

        if (vcConfig.namespace.ViewController.disposePlugins) {
            for (i = 0; i < vcConfig.namespace.ViewController.disposePlugins.length; i++) {
                vcConfig.namespace.ViewController.disposePlugins[i].call(this);
            }
        }

        this.unbindViewEvent();
        this.viewEventsHandler.unbindEvent();

        for (i = 0; i < this.viewControllers.length; i++) {
            if (!this.viewControllers[i].disposed) {
                this.viewControllers[i].dispose();
            }
            this.viewControllers[i] = null;
        }
        this.viewControllers = [];

        if (this.view) {
            this.view.style.display = 'none';
            this.view.innerHTML = '';
        }

        if (this.view && this.view.parentNode) {
            this.view.parentNode.removeChild(this.view);
        }

        if(lpTag.WebAgent.logicController.isDevEnvironment()){
            if (!this.view) {
                this.logger.error("disposing VC, this.view is undefined!", "dispose");
            }
        }

        var controllerName = this.ControllerName;
        this.view = null;
        for (var key in this) {
            if (this.hasOwnProperty(key)) {
                this[key] = null;
                delete this[key];
            }
        }
        this.disposed = true;
        this.ControllerName = controllerName;
    };


    return vcConfig.namespace.ViewController;

});
